Revolution.Module.extend({
    NAME: "mde.sliders", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "equalheight", "runEqualHeight", "getHeightsForOffsets");

        //events

        this.initSliders();

    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {

    },

    initSliders: function () {
        $('.js-bk-slider').each(function (index, elem) {
            var slider = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 1,
                spaceBetween: 25,
                freeMode: true,
                // loop: true,

                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 5,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    }
                },

                navigation: {
                    nextEl: $(elem).find('.swiper-button-next'),
                    prevEl: $(elem).find('.swiper-button-prev'),
                },
            });

            window.bLazy.load($(elem).find('.lazy'));
        });
    }

});
